import utils from '@/app/utils/gfUtils';
import HELPER from '@/app/utils/HELPER';
import renderSnippets from '@/app/editor/sidebar/renderSnippets';
import InteractionPanel from '@/app/editor/sidebar/interactions';
import FlowActionsPanel from '@/app/editor/sidebar/actions';
import { app } from '@/store';
import { renderTabSettings } from './global-style/renderTabSetting';

(function (jQuery) {
  jQuery.gfSettingGroup = function (element, options) {
    const defaults = {};

    this.settings = {};
    const $element = jQuery(element);

    const _this = this;
    let $targetElement;

    const _data = {
      advanced: false,
      reset: false,
    };
    const _dataModule = [];

    let $gfSGPopup;

    /* Editor */
    const $gfLeftSideBar = jQuery('#gfLeftSideBar');
    const $gfResTool = jQuery('#gfResTool');

    /* Iframe */
    const $gfFrame = jQuery('#gfFrame');
    const $gryffEditor = $gfFrame.contents().find('.gryffeditor').first();
    const $gryffBody = $gfFrame.contents().find('body').first();

    this.init = function () {
      this.settings = jQuery.extend({}, defaults, options);

      const merId = $gfLeftSideBar.find('#md-settings').data('edittingID');
      $targetElement = $gryffBody.find('#' + merId);

      // if columns has no-render => no render;
      if ($element.attr('data-render') == 'no-render') {
        $element.hide();
        return false;
      }

      _data['count'] = $element.find('.gfSGSettings input, .gfSGSettings select, .gfSGSettings textarea').length;

      _this.setContent();
      _this.applyEventsAdv();
      _this.onEvent();

      return false;
    };

    this.applyEventsAdv = function () {
      if ($element.attr('data-advanced')) {
        // Event ADV
        const $advanced = $element.next('.columns-advanced');

        $element
          .find('.gfSGSettings')
          .append(
            '<button type="button" class="gfSGAdv"><p>More settings</p><svg class="help-me-name-it-bruh" height="10px" viewBox="0 0 3 10"><path d="M0.6,2L3,4.5L0.6,7L0,6.4l1.9-1.9L0,2.6L0.6,2z" style="fill: #85929E;" /></svg></button>',
          );
        $advanced.gfSettingAdv();
        $advanced
          .find('.gfSGSettings')
          .after(
            '<button type="button" class="gfSGBack"><svg class="help-me-name-it-bruh" height="10px" viewBox="0 0 3 10"><path d="M3,2.6L1.1,4.5L3,6.4L2.4,7L0,4.5L2.4,2L3,2.6z" style="fill: #85929E;" /></svg><p>Back</p></button>',
          );
        const _this = this;
        function eventOpenAdv() {
          $element
            .find('.gfSGAdv')
            .off('click')
            .on('click', function () {
              _this.resizePopupAdvanced($advanced);

              $element.off('click');

              // Check hover
              if ($element.attr('hover')) {
                $advanced.data('gfsettinggroup').hoverOn(false);
                $advanced.data('gfsettingadv').onShow();

                _this.hoverClose();
              } else {
                $advanced.data('gfsettingadv').onShow();
                _this.offOpacity();
              }

              // Check responsive
              if ($element.attr('data-resposive')) {
                const value = $element.attr('data-resposive');
                _this.resposiveClose();
                $advanced.data('gfsettinggroup').resposiveOn(value);
              }

              // Off scroll
              $gfLeftSideBar.find('.optiscroll-v').css({
                display: 'none',
              });
              // Phủ background Iframe;
              $gfLeftSideBar.data('gfleftsidebar').onBackgroundIframe('backgroundAdv');
              setTimeout(function () {
                $gryffBody
                  .find('.backgroundAdv')
                  .off('mousedown.removeBackground')
                  .on('mousedown.removeBackground', function () {
                    let found = false;
                    $gryffBody.find('.gfSideBarOverlay').each(function () {
                      const $this = jQuery(this);
                      if (!$this.hasClass('backgroundAdv') && $this.hasClass('show') && !found) {
                        $this.trigger('mousedown');
                        found = true;
                        return;
                      }
                    });
                    if (!found) {
                      $advanced.find('.gfSGBack').click();
                    }
                  });
              }, 0);

              //Check requires V2
              const $dataElement = $advanced.find('input, textarea, select');
              for (let j = 0; j < $dataElement.length; j++) {
                const $formElement = $($dataElement[j]);
                HELPER.checkRequires($advanced, $formElement);
              }

              // SUPPORT GLOBAL STYLE
              const gsKey = $gfLeftSideBar.find('#md-settings').find('.md-title .mer-title').attr('data-key');
              renderTabSettings.visibleSettingGlobalStyle(gsKey);
            });
        }

        $advanced.find('.gfSGBack').click(function () {
          $element.css({
            overflow: 'inherit',
          });
          $advanced.find('.gfSettingGroup').css({
            height: 'auto',
          });
          $advanced.find('.gfSGSettings').removeClass('optiscroll');
          $advanced.off('click');
          $advanced.css({
            'z-index': '50',
            display: 'none',
          });

          if ($advanced.attr('hover')) {
            _this.hoverOn();
            $advanced.data('gfsettinggroup').hoverClose(false);
          }

          if ($advanced.attr('resposive')) {
            const value = $advanced.attr('resposive');
            _this.resposiveOn(value);
            $advanced.data('gfsettinggroup').resposiveClose();
          }

          $($element)
            .off('click')
            .on('click', function (e) {
              $gfLeftSideBar.find('.columns').css({
                'z-index': '50',
              });
              $element.css({
                'z-index': '200',
              });
            });
          $element.click();
          $advanced.data('gfsettinggroup').offOpacity();

          // Event Back Adv
          if ($element.find('.gf-border-width').length > 0) {
            $element.find('.gf-border-width').data('gfborderwidthall').refresh();
          }
          if ($element.find('.gf-border-radius').length > 0) {
            $element.find('.gf-border-radius').data('gfborderradiusall').refresh();
          }
          $gfLeftSideBar.find('.optiscroll-v').css({
            display: 'block',
          });

          $gryffBody.find('.backgroundAdv').off('mousedown.removeBackground');
          $gfLeftSideBar.data('gfleftsidebar').offBackgroundIframe('backgroundAdv');

          return false;
        });

        // Check requires lock button adv;
        function checkLockButtonAdvanced() {
          const $inputElement = $advanced.find('input,select,textarea');
          let found = true;
          for (let j = 0; j < $inputElement.length; j++) {
            const $formElement = $($inputElement[j]);
            const _requires =
              typeof $formElement.attr('requires') !== undefined ? $formElement.attr('requires') : false;
            if (_requires) {
              found = false;
              // Tách các requires đồng thời
              var listRequire = _requires.split('+');

              function loopRequires() {
                for (var i = 0; i < listRequire.length; i++) {
                  var $dadRequire;
                  const require = listRequire[i];

                  const attrId = require.split('|')[0];
                  const attrValue = require.split('|')[1];

                  // Check elm in Advenced
                  const $elm = $advanced.find('#' + attrId);
                  if ($elm.length > 0) {
                    continue;
                  }

                  $dadRequire = jQuery($gfLeftSideBar.find('#' + attrId));

                  // Check value in requireValues
                  let found = false;
                  let requiresValue = $dadRequire.attr('value-requires');
                  if (requiresValue) {
                    var arrayRequires = requiresValue.split(':');
                  } else {
                    arrayRequires = [];
                  }
                  for (let k = 0; k < arrayRequires.length; k++) {
                    if (arrayRequires[k] == attrValue) {
                      found = true;
                      break;
                    }
                  }
                  if (found) {
                    continue;
                  }

                  // Check elm in Advenced
                  if (requiresValue) {
                    requiresValue += attrValue + ':';
                  } else {
                    requiresValue = attrValue + ':';
                  }

                  $dadRequire.attr('value-requires', requiresValue);
                  arrayRequires = requiresValue.split(':');

                  // Init require
                  if ($dadRequire.length > 0) {
                    let count = 0;
                    for (var i = 0; i < arrayRequires.length; i++) {
                      if ($dadRequire.attr('value') == arrayRequires[i]) {
                        $element.find('.gfSGAdv').attr('lock', 'false');
                        eventOpenAdv();
                        count++;
                      }
                    }
                    if (count == 0) {
                      $element.find('.gfSGAdv').attr('lock', 'true');
                      $element.find('.gfSGAdv').off('click');
                    }
                  } else {
                    eventOpenAdv();
                  }

                  // Event require
                  if ($dadRequire.length > 0) {
                    $dadRequire.on('on-require', function () {
                      let count = 0;
                      for (let i = 0; i < arrayRequires.length; i++) {
                        if ($dadRequire.attr('value') == arrayRequires[i]) {
                          $element.find('.gfSGAdv').attr('lock', 'false');
                          eventOpenAdv();
                          $element.find('.gfSGAdv').addClass('highlight');
                          setTimeout(function () {
                            $element.find('.gfSGAdv').removeClass('highlight');
                          }, 1000);
                          count++;
                        }
                      }
                      if (count == 0) {
                        $element.find('.gfSGAdv').attr('lock', 'true');
                        $element.find('.gfSGAdv').off('click');
                      }
                    });
                  }
                }
              }
              loopRequires();
            }
          }

          if (found) {
            eventOpenAdv();
          }
        }
        checkLockButtonAdvanced();

        const _requires = typeof $advanced.attr('requires') !== undefined ? $advanced.attr('requires') : false;
        if (_requires) {
          const listRequire = _requires.split('+');
          for (let k = 0; k < listRequire.length; k++) {
            const require = listRequire[k];

            const arrayRequires = require.split('|');
            const attrId = arrayRequires[0];
            var attrValue = arrayRequires[1];
            var $dadRequire = jQuery($element.find('#' + attrId));
            var $btnAdv = $element.find('.gfSGAdv');

            let hideFieldInit = true;
            const list_require = attrValue.split(':');
            for (let i = 0; i < list_require.length; i++) {
              if ($dadRequire.attr('value') !== list_require[i]) {
              } else {
                hideFieldInit = false;
              }
            }
            if (hideFieldInit) {
              $btnAdv.hide();
            } else {
              $btnAdv.show();
            }

            // EVENT SWTICH
            $dadRequire.on('on-require', function () {
              let hideField = true;
              const list_require = attrValue.split(':');
              for (let i = 0; i < list_require.length; i++) {
                if ($dadRequire.attr('value') == list_require[i]) {
                  hideField = false;
                }
              }

              if (hideField) {
                $btnAdv.hide();
              } else {
                $btnAdv.show();
              }
            });
          }
        }
      }
      return false;
    };

    this.resizePopupAdvanced = function ($advanced, isReset = false) {
      let $elmColumns = $element;
      if ($elmColumns.hasClass('columns-advanced')) {
        $elmColumns = $elmColumns.prev('.columns');
      }
      // Reset popup
      if (isReset) {
        $advanced.find('.gfSettingGroup').css({
          height: 'auto',
        });
        $advanced.find('.gfSGSettings').removeClass('optiscroll');
      }

      const $leftSideBarBody = $gfLeftSideBar.find('#md-settings .md-body.active');
      const advancedHeight = $advanced.height();
      const leftSideBarHeight = $leftSideBarBody.height();
      let top = $elmColumns.offset().top;
      top = top - 50;
      if (top < 120) {
        top = 120;
        if (top + advancedHeight + 50 > $(window).height()) {
          var height = leftSideBarHeight - 50 - top;
          if (advancedHeight + 50 > height) {
            $elmColumns.css({
              overflow: 'hidden',
            });
            $advanced.find('.gfSettingGroup').css({
              height: height,
              'margin-bottom': '42px',
            });

            $advanced.find('.gfSGSettings').addClass('optiscroll').optiscroll();
          }
        }
      } else if (top + advancedHeight + 50 > leftSideBarHeight) {
        top = 120;
        var height = leftSideBarHeight - 50 - top;
        if (advancedHeight + 50 > height) {
          $elmColumns.css({
            overflow: 'hidden',
          });
          $advanced.find('.gfSettingGroup').css({
            height: height,
            'margin-bottom': '42px',
          });
          $advanced.find('.gfSGSettings').addClass('optiscroll').optiscroll();
        }
      }
      $advanced.css({
        top: top,
      });
      return;
    };

    this.onChangeResponsive = function (dataName) {
      let screenSize = 'lg';
      switch (dataName) {
        case 'Desktop':
          screenSize = 'lg';
          break;

        case 'Laptop':
          screenSize = 'md';
          break;

        case 'Tablet':
          screenSize = 'sm';
          break;

        case 'Mobile':
          screenSize = 'xs';
          break;
      }
      _this.setResponsive($element, dataName);

      $gfResTool.find('.select-screen a[data-size="' + screenSize + '"]').trigger('click');
      return false;
    };

    this.setResponsive = function ($data, dataName) {
      $data.attr('resposive', dataName);
      const _iconButtonReponsive = utils.chooseResponsiveIcon(dataName);
      const $buttonReponsiveBar = $data.find('.gfSGTitleBarResposive');
      $buttonReponsiveBar.html(_iconButtonReponsive);

      return false;
    };

    const _renderResponsive = function () {
      const $buttonReponsive = $element.find('.gfSGTitleBarResposive');
      $buttonReponsive.click(function (e) {
        if ($buttonReponsive.attr('class') == 'gfSGTitleBarResposive') {
          const screenType =
            $gfResTool.data('gfrestool') != undefined ? $gfResTool.data('gfrestool').getCurrentStatus() : 'lg';
          var value = 'Desktop';
          switch (screenType) {
            case 'lg':
              value = 'Desktop';
              break;

            case 'md':
              value = 'Laptop';
              break;

            case 'sm':
              value = 'Tablet';
              break;

            case 'xs':
              value = 'Mobile';
              break;
          }
          _this.resposiveOn(value);
          //Check responsive: onclick show reponsive element class="field-hide-all"
          if ($element.hasClass('field-hide-all')) {
            var $elements_Hide = $gfLeftSideBar.find('.columns.field-hide-all');
            for (var i = 0; i < $elements_Hide.length; i++) {
              var $element_Hide = $($elements_Hide[i]);
              var text_title = $element_Hide.find('.gfSGTitleBarTitle').text();
              // equa title element hide => init elemnt
              if (text_title == $element.find('.gfSGTitleBarTitle').text()) {
                $element_Hide.data('gfsettinggroup').resposiveOn(value);
              }
            }
          }

          // Nếu đang mở toggle thì cho đóng mở responsive
          if ($element.attr('data-toggle') == 'true') {
            return false;
          }
        } else {
          _this.resposiveClose();
          //Check responsive: onclick show reponsive element class="field-hide-all"
          if ($element.hasClass('field-hide-all')) {
            var $elements_Hide = $gfLeftSideBar.find('.columns.field-hide-all');
            for (var i = 0; i < $elements_Hide.length; i++) {
              var $element_Hide = $($elements_Hide[i]);
              var text_title = $element_Hide.find('.gfSGTitleBarTitle').text();
              // equa title element hide => init elemnt
              if (text_title == $element.find('.gfSGTitleBarTitle').text()) {
                $element_Hide.data('gfsettinggroup').resposiveOn(value);
              }
            }
          }
          return false;
        }
      });
    };

    this.buttonResponsiveClick = function () {
      const $btnReponsive = $element.find('.gfSGResponsiveTools button');

      $btnReponsive.off('click').on('click', function () {
        $btnReponsive.removeClass('active');
        const $this = jQuery(this);
        $this.addClass('active');
        const dataName = $this.attr('data-caption');

        _this.onChangeResponsive(dataName);

        return false;
      });

      return false;
    };

    const _renderHover = function () {
      const $buttonHover = $element.find('.gfSGTitleBarHover');
      $buttonHover.click(function (e) {
        e.preventDefault();
        if ($buttonHover.attr('class') == 'gfSGTitleBarHover') {
          _this.hoverOn();
        } else {
          _this.hoverClose();
        }
      });

      return false;
    };

    this.setAdvanced = function (value) {
      _data['advanced'] = value;
    };

    this.resposiveOn = function (value) {
      const $buttonReponsive = $element.find('.gfSGTitleBarResposive');
      const resposiveData = ['Desktop', 'Laptop', 'Tablet', 'Mobile'];
      let html = '<div class="gfSGResponsiveTools">';
      const itemDOM = [];

      for (let i = 0; i < resposiveData.length; i++) {
        if (value == resposiveData[i]) {
          html +=
            '<button type="button" data-caption="' +
            resposiveData[i] +
            '" class="active">' +
            resposiveData[i] +
            '</button>';
        } else {
          html += '<button type="button" data-caption="' + resposiveData[i] + '">' + resposiveData[i] + '</button>';
        }
      }

      html += '</div>';
      $buttonReponsive.addClass('onActive');
      const $reponsiveBar = $element.find('.gfSGResponsive');
      $reponsiveBar.html(html);

      const _iconButtonReponsive = utils.chooseResponsiveIcon(value);

      const $buttonReponsiveBar = $element.find('.gfSGTitleBarResposive');
      $buttonReponsiveBar.html(_iconButtonReponsive);

      _this.buttonResponsiveClick();
      $element.attr('resposive', value);

      return false;
    };

    this.resposiveClose = function () {
      const $buttonReponsive = $element.find('.gfSGTitleBarResposive');
      $buttonReponsive.removeClass('onActive');

      const $reponsiveBar = $element.find('.gfSGResponsive');
      $reponsiveBar.html('');

      $element.attr('resposive', '');

      return false;
    };

    this.hoverOn = function () {
      $element.find('.gfSettingGroup').css({
        'z-index': '200',
      });

      $element.attr('hover', 'true');
      if (_data['advanced'] == false) {
        _this.onOpacity();
      }
      const $buttonHover = $element.find('.gfSGTitleBarHover');
      $buttonHover.addClass('active');

      const $barHover = $element.find('.gfSGBarHover');
      $barHover.addClass('gfSGShow');

      const $settinggroup = $element.find('.gfSettingGroup');
      $settinggroup.addClass('gfActiveHover');

      $element.find('.gfSettingGroup').append('<div class="gfSGOkDone">OK, Done!</div>');
      $element
        .find('.gfSGOkDone')
        .off('click')
        .on('click', function () {
          _this.hoverClose();
        });
      return false;
    };

    this.hoverClose = function () {
      $element.attr('hover', '');
      if (_data['advanced'] == false) {
        _this.offOpacity();
        $element.find('.gfSettingGroup').css({
          'z-index': '30',
        });
      }
      const $buttonHover = $element.find('.gfSGTitleBarHover');
      $buttonHover.removeClass('active');

      const $barHover = $element.find('.gfSGBarHover');
      $barHover.removeClass('gfSGShow');

      const $settinggroup = $element.find('.gfSettingGroup');
      $settinggroup.removeClass('gfActiveHover');

      $element.find('.gfSGOkDone').remove();
      return false;
    };

    this.resetHover = function () {
      const $btnResetHover = $element.find('.gfSGBarHoverIcon');
      $btnResetHover.off('click').on('click', function () {});
      return false;
    };

    this.onOpacity = function () {
      $element.find('.gfSGBackground').css({
        display: 'block',
      });
      $gfLeftSideBar.find('.optiscroll-v').css({
        display: 'none',
      });
      return false;
    };

    this.offOpacity = function () {
      if (!$element.attr('hover') && !_data['advanced'] == true) {
        $element.find('.gfSGBackground').css({
          display: 'none',
        });
      }
      $gfLeftSideBar.find('.optiscroll-v').css({
        display: 'block',
      });
      return false;
    };

    /*  Code Popup in group settings  */
    this.renderPopup = function ($html, isButton) {
      if (!$html) {
        return false;
      }
      $gfSGPopup = $element.find('.gfSGPopup');
      if ($gfSGPopup.length == 0) {
        $element.append('<div class="gfSGPopup"></div>');
        $gfSGPopup = $element.find('.gfSGPopup');
      }
      $gfSGPopup.html('<div class="gfSGPopupBody"></div>');
      $gfSGPopup.find('.gfSGPopupBody').html($html);
      if (isButton) {
        $gfSGPopup
          .find('.gfSGPopupBody')
          .append(
            '<span class="gfSGPopupError"></span><div class="gfSGPopupBodyBtn"><span class="gfSGPopupCancel">Cancel</span><span class="gfSGPopupDone">Done</span></div>',
          );
        $gfSGPopup
          .find('.gfSGPopupCancel')
          .off('click.closepopup')
          .on('click.closepopup', function () {
            _this.hidePopup();
          });
      }
    };

    this.showPopup = function ($target, isPositionExactly) {
      if (!$target) {
        // $target not found
        return false;
      }

      let top = $target.offset().top;
      top = top - parseInt($target.outerHeight(true));
      if (top + $gfSGPopup.outerHeight(true) + 80 > $(window).height()) {
        top = top + $gfSGPopup.outerHeight(true) + 50;
        const srcollTop = top - $(window).height();
        top = $target.offset().top - (srcollTop + 80);
      } else if (top < 0) {
        top = 60;
      } else if (!isPositionExactly) {
        top = top - 30;
      }
      $gfSGPopup.css({
        top: top,
      });

      $element.find('.gfSettingGroup').css({
        'z-index': '30',
      });

      _this.onOpacity();
      $gfSGPopup.addClass('show');
      $gfSGPopup.click(); // Cho z-index tăng lên;

      // background phủ iframe
      $gfLeftSideBar.data('gfleftsidebar').onBackgroundIframe('backgroundSGPopup');
      setTimeout(function () {
        $gryffBody
          .find('.backgroundSGPopup')
          .off('mousedown.removeBackground')
          .on('mousedown.removeBackground', function () {
            _this.hidePopup();
          });
      }, 0);

      $gfLeftSideBar
        .find('.gfSGBackground')
        .off('mousedown.removeBackground')
        .on('mousedown.removeBackground', function (e) {
          _this.hidePopup();
        });
    };

    this.hidePopup = function () {
      $gfSGPopup.removeClass('show');
      _this.offOpacity();
      $gryffBody.find('.backgroundSGPopup').off('mousedown.removeBackground');
      $gfLeftSideBar.data('gfleftsidebar').offBackgroundIframe('backgroundSGPopup');
      $gfLeftSideBar.find('.gfSGBackground').off('mousedown.removeBackground');

      $element.trigger('popup-hide');

      $element.find('.gfSettingGroup').css({
        'z-index': '200',
      });
    };

    /*  Code Apply styles for all screens each $formElement  */
    this.initApplyStyleForAll = function ($formElement) {
      if (!_this.checkAvailabilityApplyStyle($formElement)) {
        return false;
      }

      const $subTitle = _this.getSubTitle($formElement);

      const isApplyStyleInit = _this.checkValueAllScreen($formElement);
      if (isApplyStyleInit) {
        $subTitle.addClass('activeApplyStyle');
      }

      let delayCheckApplyStyle;
      $formElement.on('input-change', function () {
        try {
          clearTimeout(delayCheckApplyStyle);
          delayCheckApplyStyle = setTimeout(function () {
            const isApplyStyle = _this.checkValueAllScreen($formElement);
            if (isApplyStyle) {
              $subTitle.addClass('activeApplyStyle');
            } else {
              $subTitle.removeClass('activeApplyStyle');
            }
          }, 100);
        } catch (error) {
          console.log(error);
        }
      });

      _this.eventApplyStyle($formElement);
      return false;
    };

    this.getSubTitle = function ($formElement) {
      const $formSetting = $formElement.next();
      let currentTab = $gfLeftSideBar.find('.simple-tabs ul.simple-tabs-item li.active').text();
      currentTab = currentTab.trim();
      switch (currentTab) {
        case 'Settings':
          var $subTitle = $formSetting.find('.gfSGSubTitle').first(); // Lấy thằng title đầu tiên
          if ($subTitle.length == 0 || $subTitle.text() == '') {
            $subTitle = $element.find('.gfSGTitleBarTitle').first(); // Lấy thằng title đầu tiên của columns
          }
          break;
        case 'Design':
          if (
            $formElement.attr('name') == 'margin-top' ||
            $formElement.attr('name') == 'margin-left' ||
            $formElement.attr('name') == 'margin-right' ||
            $formElement.attr('name') == 'margin-bottom'
          ) {
            var $wrapMargin = $formElement.closest('.gf_margin-wrapper');
            var $subTitle = $wrapMargin.prev('.gfSGSubTitle');
          } else if (
            $formElement.attr('name') == 'padding-top' ||
            $formElement.attr('name') == 'padding-left' ||
            $formElement.attr('name') == 'padding-right' ||
            $formElement.attr('name') == 'padding-bottom'
          ) {
            var $wrapMargin = $formElement.closest('.gf_padding-wrapper');
            var $subTitle = $wrapMargin.prev('.gfSGSubTitle');
          } else {
            var $subTitle = $formSetting.find('.gfSGSubTitle').first(); // Lấy thằng title đầu tiên
            if ($subTitle.length == 0 || $subTitle.text() == '') {
              $subTitle = $element.find('.gfSGTitleBarTitle').first(); // Lấy thằng title đầu tiên của columns
            }
          }
          break;
      }
      return $subTitle;
    };

    this.checkAvailabilityApplyStyle = function ($formElement) {
      // var currentTab = $gfLeftSideBar.find('.simple-tabs').data('gftabs').getCurrentTab();
      let currentTab = $gfLeftSideBar.find('.simple-tabs ul.simple-tabs-item li.active').text();
      currentTab = currentTab.trim();
      switch (currentTab) {
        case 'Settings':
          // Không hỗ trợ responsive thì dừng luôn.
          var responsive =
            typeof $element.attr('data-responsive') !== 'undefined' ? $element.attr('data-responsive') : '';
          if (!responsive || responsive == '') {
            return false;
          }

          // Không có title thì dừng lại luôn.
          var title = typeof $formElement.attr('data-caption') !== 'undefined' ? $formElement.attr('data-caption') : '';
          if (!title || title == '') {
            return false;
          }

          // Không được apply style for all thì dừng lại luôn.
          var isNoApplyStyle =
            typeof $formElement.attr('noapplystyle') !== 'undefined' ? $formElement.attr('noapplystyle') : false;
          if (isNoApplyStyle == true || isNoApplyStyle == 'true') {
            return false;
          }

          // Không có targetClass thì dừng lại luôn. < Các module cũ >
          var targetclass =
            typeof $formElement.attr('targetclass') !== 'undefined' ? $formElement.attr('targetclass') : '';
          if (!targetclass || targetclass == '') {
            return false;
          }

          // Không được định nghĩa reference thì dừng lại luôn. < Các module cũ >
          var reference = typeof $formElement.attr('reference') !== 'undefined' ? $formElement.attr('reference') : '';
          if (!reference || reference == '') {
            return false;
          }

          return true;

        case 'Design':
          // Không được định nghĩa reference thì dừng lại luôn. < Các module cũ >
          var reference = typeof $formElement.attr('reference') !== 'undefined' ? $formElement.attr('reference') : '';
          if (!reference || reference == '') {
            return false;
          }
          // Không được apply style for all thì dừng lại luôn.
          var isNoApplyStyle =
            typeof $formElement.attr('noapplystyle') !== 'undefined' ? $formElement.attr('noapplystyle') : false;
          if (isNoApplyStyle == true || isNoApplyStyle == 'true') {
            return false;
          }
          // Không hỗ trợ responsive thì dừng luôn.
          var responsive =
            typeof $element.attr('data-responsive') !== 'undefined' ? $element.attr('data-responsive') : '';
          if (!responsive || responsive == '') {
            return false;
          }

          // Dừng sự kiện bên design của Margin,Padding;
          if (
            $formElement.attr('name') == 'margin-top' ||
            $formElement.attr('name') == 'margin-left' ||
            $formElement.attr('name') == 'margin-right' ||
            $formElement.attr('name') == 'margin-bottom'
          ) {
            return false;
          } else if (
            $formElement.attr('name') == 'padding-top' ||
            $formElement.attr('name') == 'padding-left' ||
            $formElement.attr('name') == 'padding-right' ||
            $formElement.attr('name') == 'padding-bottom'
          ) {
            return false;
          }

          if ($targetElement.data('gfrow') != undefined) {
            $formElement.attr('targetclass', 'self');
          } else if ($targetElement.data('gfmodule') != undefined) {
            var targetClass = $targetElement.data('gfmodule').getTargetClass();
            if (targetClass == '') {
              $formElement.attr('targetclass', 'self');
            } else {
              $formElement.attr('targetclass', targetClass);
            }
          } else if ($targetElement.data('gfelement') != undefined) {
            var targetClass = $targetElement.data('gfelement').getTargetClass();
            if (
              targetClass == '' ||
              $formElement.attr('name') == 'margin-top' ||
              $formElement.attr('name') == 'margin-left' ||
              $formElement.attr('name') == 'margin-right' ||
              $formElement.attr('name') == 'margin-bottom'
            ) {
              $formElement.attr('targetclass', 'self');
            } else {
              $formElement.attr('targetclass', targetClass);
            }
          }
          return true;
      }
    };

    this.getTargetClassFormElement = function ($formElement) {
      let targetclass = $formElement.attr('targetclass');
      if (!targetclass) {
        return false;
      }
      // Dành riêng cho heading có dạng: .text-edit+heading
      if (targetclass.indexOf('+heading') !== -1) {
        let newTargetclass = targetclass.split('+')[0];
        const $heading = $targetElement.find(newTargetclass).children('h1,h2,h3,h4,h5,h6');
        if ($heading.length > 0) {
          switch ($heading.prop('tagName').toLowerCase()) {
            case 'h1':
              newTargetclass += ' h1';
              break;

            case 'h2':
              newTargetclass += ' h2';
              break;

            case 'h3':
              newTargetclass += ' h3';
              break;

            case 'h4':
              newTargetclass += ' h4';
              break;

            case 'h5':
              newTargetclass += ' h5';
              break;

            case 'h6':
              newTargetclass += ' h6';
              break;
          }
        }
        targetclass = newTargetclass;
      }
      return targetclass;
    };

    this.getCurrentTarget = function (targetclass) {
      // Kiểm tra và tìm ra dom tương tứng targetclass
      let $currentTarget;
      if (targetclass == 'self') {
        $currentTarget = $targetElement;
      } else {
        let newTargetClass = targetclass;
        newTargetClass = newTargetClass.replace(':hover', '');
        newTargetClass = newTargetClass.replace(':after', '');
        newTargetClass = newTargetClass.replace(':before', '');
        $currentTarget = $targetElement.find(newTargetClass).first();
      }
      return $currentTarget;
    };

    this.checkValueAllScreen = function ($formElement) {
      const devices = ['xs', 'sm', 'md', 'lg'];
      const targetclass = _this.getTargetClassFormElement($formElement);
      if (targetclass) {
        const reference = $formElement.attr('reference');
        // Bóc tách reference có dạng css|font-size
        const ref = reference.split('|');
        const type = ref[0]; // css
        const attribute = ref[1]; // font-size

        const $currentTarget = _this.getCurrentTarget(targetclass);

        if ($currentTarget && $currentTarget.length > 0) {
          switch (type) {
            case 'css':
              var style = '';
              if ($targetElement.data('gfrow') != undefined) {
                var style = $targetElement.data('gfrow').getRowCSS();
              } else if ($targetElement.data('gfmodule') != undefined) {
                var style = $targetElement.data('gfmodule').getModuleCSS();
              } else if ($targetElement.data('gfelement') != undefined) {
                var style = $targetElement.data('gfelement').getElementCSS();
              }
              var defaultCssValue;
              for (var index = 0; index < devices.length; index++) {
                var screenType = devices[index];
                var cssValue = _this.getValueTarget($formElement, screenType, style); // Lấy giá trị trên màn hình cụ thể
                if (index == 0) {
                  // Khởi tạo giá trị đầu tiên
                  defaultCssValue = cssValue;
                } else {
                  // Từ lần 1,2,3,4 thì sẽ kiểm tra
                  if (defaultCssValue != cssValue) {
                    // Nếu giá trị 0 != 1 or 1 != 2 thì dừng lại và trả về true;
                    return true;
                  } else {
                    // Nếu giống thì tiếp tục gán 0=1 or 1=2 và chạy tiếp
                    defaultCssValue = cssValue;
                  }
                }
              }
              break;
            case 'class':
              var defaultCssValue;
              for (var index = 0; index < devices.length; index++) {
                var screenType = devices[index];
                var cssValue = _this.getValueTarget($formElement, screenType, style); // Lấy giá trị trên màn hình cụ thể
                if (index == 0) {
                  // Khởi tạo giá trị đầu tiên
                  defaultCssValue = cssValue;
                } else {
                  // Từ lần 1,2,3,4 thì sẽ kiểm tra
                  if (defaultCssValue != cssValue) {
                    // Nếu giá trị 0 != 1 or 1 != 2 thì dừng lại và trả về true;
                    return true;
                  } else {
                    // Nếu giống thì tiếp tục gán 0=1 or 1=2 và chạy tiếp
                    defaultCssValue = cssValue;
                  }
                }
              }
              break;
            case 'attr':
              var defaultCssValue;
              for (var index = 0; index < devices.length; index++) {
                var screenType = devices[index];
                var cssValue = _this.getValueTarget($formElement, screenType, style); // Lấy giá trị trên màn hình cụ thể
                if (index == 0) {
                  // Khởi tạo giá trị đầu tiên
                  defaultCssValue = cssValue;
                } else {
                  // Từ lần 1,2,3,4 thì sẽ kiểm tra
                  if (defaultCssValue != cssValue) {
                    // Nếu giá trị 0 != 1 or 1 != 2 thì dừng lại và trả về true;
                    return true;
                  } else {
                    // Nếu giống thì tiếp tục gán 0=1 or 1=2 và chạy tiếp
                    defaultCssValue = cssValue;
                  }
                }
              }
              break;
          }
        }
      }
      return false;
    };

    this.getValueTarget = function ($formElement, screenType, style) {
      const targetclass = _this.getTargetClassFormElement($formElement);
      if (targetclass) {
        const reference = $formElement.attr('reference');
        // Bóc tách reference có dạng css|font-size
        const ref = reference.split('|');
        const type = ref[0]; // css
        const attribute = ref[1]; // font-size
        var $currentTarget;
        if (!$currentTarget) {
          var $currentTarget = _this.getCurrentTarget(targetclass);
        }
        switch (type) {
          case 'css':
            if (!style) {
              if ($targetElement.data('gfrow') != undefined) {
                style = $targetElement.data('gfrow').getRowCSS();
              } else if ($targetElement.data('gfmodule') != undefined) {
                style = $targetElement.data('gfmodule').getModuleCSS();
              } else if ($targetElement.data('gfelement') != undefined) {
                style = $targetElement.data('gfelement').getElementCSS();
              }
            }

            if (
              attribute == 'box-shadow-style' ||
              attribute == 'box-shadow-color' ||
              attribute == 'box-shadow-type' ||
              attribute == 'box-shadow-blur' ||
              attribute == 'box-shadow-spread' ||
              attribute == 'box-shadow-distance' ||
              attribute == 'box-shadow-angle'
            ) {
              if (targetclass == 'self') {
                var boxShadow = HELPER.getValueFromCSS($currentTarget, style, 'box-shadow', screenType);
              } else {
                var boxShadow = HELPER.getValueFromCSS($currentTarget, style, 'box-shadow', screenType, targetclass);
              }
              if (boxShadow.indexOf('inset') !== -1) {
                var shadowType = 'inset';
              } else {
                var shadowType = 'outset';
              }
              const shadowVal = boxShadow.match(/-?(\d)+\.(\d+px)|(-?\d+px)|(rgb\(.+\))|(rgba\(.+\))/g);
              if (shadowVal != undefined && shadowVal.length > 0) {
                shadowVal.unshift(shadowType);
                let shadowColorVal = boxShadow.split(' ').pop();

                const shadowX = shadowVal[1];
                const shadowY = shadowVal[2];
                const shadowXY = shadowX + ',' + shadowY;

                let angle = Math.round(Math.atan2(parseInt(shadowY), parseInt(shadowX)) * (180 / Math.PI));
                if (angle < 0) {
                  angle = 360 + angle;
                }
                // Distance là cạnh huyền;
                const distance = Math.round(
                  Math.sqrt(parseInt(shadowX) * parseInt(shadowX) + parseInt(shadowY) * parseInt(shadowY)),
                );

                const shadowBlur = shadowVal[3];
                const shadowSpread = shadowVal[4];

                var shadowStyle = '';
                if (parseInt(shadowBlur) != 0 || parseInt(shadowSpread) != 0) {
                  if (parseInt(distance) == 0) {
                    var shadowStyle = 'outer';
                  } else {
                    var shadowStyle = 'drop';
                  }
                }

                shadowColorVal = HELPER.rgb2hex(shadowColorVal);

                switch (attribute) {
                  case 'box-shadow-style':
                    var cssValue = shadowStyle;
                    break;
                  case 'box-shadow-color':
                    var cssValue = shadowColorVal;
                    break;
                  case 'box-shadow-type':
                    var cssValue = shadowType;
                    break;
                  case 'box-shadow-blur':
                    var cssValue = shadowBlur;
                    break;
                  case 'box-shadow-spread':
                    var cssValue = shadowSpread;
                    break;
                  case 'box-shadow-distance':
                    var cssValue = distance;
                    break;
                  case 'box-shadow-angle':
                    var cssValue = angle;
                    break;
                }
              }
            } else {
              // Thực hiện bình thường
              if (targetclass == 'self') {
                var cssValue = HELPER.getValueFromCSS($currentTarget, style, attribute, screenType);
              } else {
                var cssValue = HELPER.getValueFromCSS($currentTarget, style, attribute, screenType, targetclass);
              }
            }
            return cssValue;
          case 'class':
            switch (attribute) {
              case 'align':
                if ($targetElement.data('gfmodule') != undefined) {
                } else if ($targetElement.data('gfelement') != undefined) {
                  const classAlignLeft = 'gf-elm-left-' + screenType;
                  const classAlignRight = 'gf-elm-right-' + screenType;
                  const classAlignCenter = 'gf-elm-center-' + screenType;
                  const classAlignJustify = 'gf-elm-justify-' + screenType;
                  if ($currentTarget.hasClass(classAlignCenter)) {
                    return 'center';
                  } else if ($currentTarget.hasClass(classAlignLeft)) {
                    return 'left';
                  } else if ($currentTarget.hasClass(classAlignRight)) {
                    return 'right';
                  } else if ($currentTarget.hasClass(classAlignJustify)) {
                    return 'justify';
                  }
                }
                return '';
            }
            break;
          case 'attr':
            return $currentTarget.attr(attribute);
        }
      }
    };

    this.eventApplyStyle = function ($formElement) {
      let currentTab = $gfLeftSideBar.find('.simple-tabs ul.simple-tabs-item li.active').text();
      currentTab = currentTab.trim();
      const $subTitle = _this.getSubTitle($formElement);
      // Sự kiện click sub title
      $subTitle.off('click.applystyle').on('click.applystyle', function (e) {
        if (!$subTitle.hasClass('activeApplyStyle')) {
          return false;
        }

        let _templateButton =
          '<svg viewBox="0 0 384 512"><path d="M192 0C79.7 101.3 0 220.9 0 300.5 0 425 79 512 192 512s192-87 192-211.5c0-79.9-80.2-199.6-192-300.5zm0 448c-56.5 0-96-39-96-94.8 0-13.5 4.6-61.5 96-161.2 91.4 99.7 96 147.7 96 161.2 0 55.8-39.5 94.8-96 94.8z" class=""></path></svg>';
        _templateButton += '<span>Apply styles for all screens</span>';

        const $that = jQuery(this);
        let _template = '<div class="gfSGApplyStyle">';
        _template += '<div class="gfSGApplyStyleTitle">' + $that.text() + '</div>';
        _template += '<div class="gfSGApplyStyleBody">';
        _template += '<button>';
        _template += _templateButton;
        _template += '</button>';
        _template +=
          '<p>* Apply current value for all screens (including desktop, laptop, tablet and mobile device).</p>';
        _template += '</div>';
        _template += '<button class="gfSGApplyStyleBack" type="button">Cancel</button>';
        _template += '</div>';
        const $backgroundApplyStyle = jQuery(_template);
        _this.renderPopup($backgroundApplyStyle);

        const isPositionExactly = true;
        _this.showPopup($that, isPositionExactly);

        $backgroundApplyStyle
          .find('.gfSGApplyStyleBack')
          .off('click')
          .on('click', function () {
            _this.hidePopup();
          });

        $backgroundApplyStyle
          .find('.gfSGApplyStyleTitle')
          .off('click')
          .on('click', function () {
            _this.hidePopup();
          });

        let isApplyStyle = false;
        $backgroundApplyStyle
          .find('.gfSGApplyStyleBody button')
          .off('click')
          .on('click', function () {
            const $button = jQuery(this);
            if (!isApplyStyle) {
              isApplyStyle = true;
              $button.html('<div class="gfSGLoadingSmall"></div>');

              const value = $formElement.attr('value');
              if ($gfResTool.data('gfrestool') != undefined && value) {
                const currentScreenType =
                  $gfResTool.data('gfrestool') != undefined ? $gfResTool.data('gfrestool').getCurrentStatus() : 'lg';
                const devices = ['xs', 'sm', 'md', 'lg'];
                try {
                  let i = 0;

                  function applyLoadDQ() {
                    if (i >= devices.length) {
                      $gfResTool.data('gfrestool').setCurrentStatus(currentScreenType);
                      $subTitle.removeClass('activeApplyStyle'); // Hoàn thành apply thì dừng lại
                      return false;
                    }
                    const screenType = devices[i];
                    if (screenType != currentScreenType) {
                      let size = 1300; // > 1200 -> desktop;
                      switch (screenType) {
                        case 'lg':
                          size = 1300;
                          break;
                        case 'md':
                          size = 992;
                          break;
                        case 'sm':
                          size = 768;
                          break;
                        case 'xs':
                          size = 480;
                          break;
                      }
                      $gfResTool.data('gfrestool').setCurrentStatus(size);
                      switch (currentTab) {
                        case 'Settings':
                          if ($formElement.hasClass('field-hide-all')) {
                            // Apply style với input dạng field-hide-all
                            var caption = $formElement.attr('data-caption');
                            var $formElementHide = $element.find(
                              '.field-hide-all.field-visible-' + screenType + '[data-caption="' + caption + '"]',
                            );
                            $formElementHide
                              .attr('value', value)
                              .val(value)
                              .trigger('input-change')
                              .trigger('value-change');
                          } else {
                            // Apply style với input bình thường
                            var oldValue = _this.getValueTarget($formElement, screenType);
                            var extra = {
                              screenType: screenType,
                              name: $formElement.attr('name'),
                              id: $formElement.attr('id'),
                              value: oldValue,
                            };
                            $gryffEditor
                              .data('gfhistory')
                              .addHistory('field-setting', $targetElement.attr('id'), extra);

                            $formElement
                              .attr('value', value)
                              .val(value)
                              .trigger('input-change')
                              .trigger('value-change');
                          }
                          break;
                        case 'Design':
                          if ($formElement.hasClass('field-hide-all')) {
                            // Apply style với input dạng field-hide-all
                            var caption = $formElement.attr('data-caption');
                            var $formElementHide = $element.find(
                              '.field-hide-all.field-visible-' + screenType + '[data-caption="' + caption + '"]',
                            );
                            $formElementHide
                              .attr('value', value)
                              .val(value)
                              .trigger('input-change')
                              .trigger('value-change');
                          } else {
                            // Apply style với input bình thường
                            var oldValue = _this.getValueTarget($formElement, screenType);
                            var extra = {
                              screenType: screenType,
                              name: $formElement.attr('name'),
                              id: $formElement.attr('id'),
                              value: oldValue,
                            };
                            $gryffEditor
                              .data('gfhistory')
                              .addHistory('field-setting', $targetElement.attr('id'), extra);

                            $formElement
                              .attr('value', value)
                              .val(value)
                              .trigger('input-change')
                              .trigger('value-change');
                          }
                          break;
                      }
                    }
                    setTimeout(function () {
                      i++;
                      applyLoadDQ(i);
                    }, 100);
                  }
                  applyLoadDQ();
                } catch (error) {
                  console.log(error);
                  $gfResTool.data('gfrestool').setCurrentStatus(currentScreenType);
                }
              }

              setTimeout(function () {
                $button.html(_templateButton);
                _this.hidePopup();
                isApplyStyle = false;
              }, 150);
            }
          });

        return false;
      });
    };

    /*  Code background  */
    this.backgroundClick = function () {
      const $background = $element.find('.gfSGBackground');
      $background.click(function () {
        if (_data['reset']) {
          _this.closeApplyStyle();
        } else if (_data['advanced'] == true) {
          const $overlays = $gryffBody.find('.gfSideBarOverlay');
          if ($overlays.length > 0) {
            let count = 0;
            for (let i = 0; i < $overlays.length; i++) {
              const $overlay = $($overlays[i]);
              if ($overlay.hasClass('show') && !$overlay.hasClass('backgroundAdv')) {
                $overlay.trigger('mousedown');
                count++;
              }
            }
            if (count == 0) {
              $element.find('.gfSGBack').click();
            }
          } else {
            $element.find('.gfSGBack').click();
          }
        } else {
          _this.hoverClose();
        }
      });

      return false;
    };

    this.setContent = function () {
      const $allElement = $element.find('input, select, textarea, [requires]');
      for (let i = 0; i < $allElement.length; i++) {
        const $formElement = jQuery($allElement[i]);

        renderSnippets($gfLeftSideBar, $gryffBody, $element, _this, $formElement, i, _data);

        _this.checkRequiresV1($formElement);
        _this.initApplyStyleForAll($formElement);
      }
      HELPER.checkFieldsHideAll($element);
      return false;
    };

    this.checkRequiresV1 = function ($formElement) {
      // Check requires V1 in columns;
      const _requires = typeof $formElement.attr('requires') !== undefined ? $formElement.attr('requires') : false;
      if (_requires && $element.hasClass('columns')) {
        HELPER.checkRequires($element, $formElement);
      }
    };

    this.onEvent = function () {
      _renderResponsive();
      // _renderHover();
      // _this.resetHover();
      _this.backgroundClick();

      $($element)
        .off('click')
        .on('click', function (e) {
          const caption = $(this).data('caption');
          if (caption == 'Interactions') {
            new InteractionPanel($targetElement);

            const $gfTabs = $gfLeftSideBar.find('.simple-tabs');

            if (
              $gfTabs != undefined &&
              $gfTabs.data('gftabs') != undefined &&
              $gfTabs.children('.interactions-panel').length
            ) {
              const interactionIndex = $gfTabs.children('.interactions-panel').index() - 1;
              $gfTabs.children('ul').hide();
              $gfTabs.data('gftabs').gotoTab(interactionIndex);
            }
          }

          if (caption == 'Flow Actions') {
            if (typeof window.__gfFlowActionsPanel != 'undefined') {
              delete window.__gfFlowActionsPanel;
            }

            window.__gfFlowActionsPanel = new FlowActionsPanel($targetElement);
            const $gfTabs = $gfLeftSideBar.find('.simple-tabs');

            if (
              $gfTabs != undefined &&
              $gfTabs.data('gftabs') != undefined &&
              $gfTabs.children('.actions-panel').length
            ) {
              const actionIndex = $gfTabs.children('.actions-panel').index() - 1;
              $gfTabs.children('ul').hide();
              $gfTabs.data('gftabs').gotoTab(actionIndex);
            }
          }

          $gfLeftSideBar.find('.columns').css({
            'z-index': '50',
          });
          $element.css({
            'z-index': '200',
          });
        });

      if ($element.attr('data-toggle') && $element.hasClass('columns')) {
        $element
          .find('.gfSGTitleBar')
          .off('click')
          .on('click', function (e) {
            if ($(e.target).closest('.activeMenu').length == 0) {
              const toggle = $element.attr('data-toggle');
              if (toggle == 'false') {
                _this.onToggle();
              } else {
                _this.offToggle();
                _this.resposiveClose();
              }
            }
            if ($(this).hasClass('show-popup-plan')) {
              app.$store.commit('app/SHOW_PLAN_MODAL', true);
            }
          });
      }
    };

    this.onToggle = function () {
      $element.attr('data-toggle', 'true');
      const name = HELPER.toHandle($element.attr('data-caption'));
      let toggle_cookie = localStorage.getItem('design_options_toggle');
      if (toggle_cookie) {
        try {
          toggle_cookie = JSON.parse(toggle_cookie);
          toggle_cookie.data[name] = {
            name: $element.attr('data-caption'),
            toggle: true,
          };
        } catch (e) {}
      } else {
        const merId = $gfLeftSideBar.find('#md-settings').data('edittingID');
        toggle_cookie = {
          id: merId,
          data: {},
        };
        toggle_cookie.data[name] = {
          name: $element.attr('data-caption'),
          toggle: true,
        };
      }
      try {
        localStorage.setItem('design_options_toggle', JSON.stringify(toggle_cookie));
      } catch (e) {
        if (e.code == 22) {
          // Storage full, maybe notify user or do some clean-up
        }
      }
      return false;
    };

    this.offToggle = function () {
      $element.attr('data-toggle', 'false');
      const name = HELPER.toHandle($element.attr('data-caption'));
      let toggle_cookie = localStorage.getItem('design_options_toggle');
      if (toggle_cookie) {
        try {
          toggle_cookie = JSON.parse(toggle_cookie);
          toggle_cookie.data[name] = {
            name: $element.attr('data-caption'),
            toggle: false,
          };
        } catch (e) {}
      } else {
        const merId = $gfLeftSideBar.find('#md-settings').data('edittingID');
        toggle_cookie = {
          id: merId,
          data: {},
        };
        toggle_cookie.data[name] = {
          name: $element.attr('data-caption'),
          toggle: false,
        };
      }
      try {
        localStorage.setItem('design_options_toggle', JSON.stringify(toggle_cookie));
      } catch (e) {
        if (e.code == 22) {
          // Storage full, maybe notify user or do some clean-up
        }
      }
    };

    this.init();
  };

  jQuery.fn.gfSettingGroup = function (options) {
    return this.each(function () {
      if (undefined == jQuery(this).data('gfsettinggroup')) {
        const plugin = new jQuery.gfSettingGroup(this, options);
        jQuery(this).data('gfsettinggroup', plugin);
      }
    });
  };
})(jQuery);
